<template>
	<v-navigation-drawer
		v-model="showModal"
		:width="clientWidth"		
		fixed
		right
		persistent
		@input="handleDrawerToggled">
		<template v-if="showModal">
			<v-toolbar dark color="primary">
			    <v-btn icon dark @click="handleClose">
			        <v-icon>close</v-icon>
			    </v-btn>
			    <v-toolbar-title>Parent Issue:</v-toolbar-title>
			</v-toolbar>
			<div class="drawer-content pa-3">
				<div class="fixed">
			        <v-sheet class="pa-0 pb-1">
			            <v-text-field v-model="inputKeyword" label="Search Issue" hide-details clearable></v-text-field>
			        </v-sheet>
				</div>
				<div class="overflow">
					<issue-list-all
						v-if="showModal"
						:selectable="true"
						:keyword="keyword"
						:issues="issues"
						@select="handleSelectIssue">
					</issue-list-all>
				</div>
			</div>
		</template>

	</v-navigation-drawer>	
</template>

<script>
	import IssueListAll from '@/components/IssueListAll.vue'
    import debounce from 'tiny-debounce'

    export default {
    	components: {
    		IssueListAll
    	},
		props: {
			show: {
				type: Boolean,
				default: false
			},
            issues: {
                type: Array,
                default: () => {
                    return []
                }
            }
		},
		data () {
			return {
				showModal: this.show,
                inputKeyword: "",
                keyword: ""
			}
		},
		computed: {
			clientWidth () 
			{
				return (window.innerWidth > 640) ? 640 : window.innerWidth
			}
		},
		methods: {
			handleDrawerToggled (value) {
				if (!value) this.$emit('close')
			},
			handleSelectIssue (issue) {
				if (issue) {
					this.$emit('select', issue)
					this.$emit('close')
				}
			},
			handleClose () {
				this.$emit('close')
			}
		},
		mounted () {
	        window.addEventListener('keyup', e => {
	            // If  ESC key was pressed...
	            if (e.keyCode === 27) {
	                // try close your dialog
	                this.handleClose()
	            }
	        })
		},
        watch: {
            inputKeyword: debounce(function (newVal) {
                this.keyword = newVal
            }, 1000),
            show (value) {
            	this.showModal = value
            },
            showModal (value) {
            	if (!value) {
            		this.$emit('close')
            	}
            }
        }
	}
</script>

<style lang="scss">
	.drawer-content {
		height: 100%;
		display: flex;
		flex-flow: column;

		.fixed {
			display: flex;
			.v-sheet {
				flex: 1;
			}
		}
		.overflow {
			flex: 1;
			overflow-y: scroll;
			overflow-x: hidden;
		}
	}
</style>